import React from "react";
import {
  Autocomplete,
  Box,
  Chip,
  CircularProgress,
  TextField,
  Checkbox,
  Typography,
  Stack,
  FormHelperText,
} from "@mui/material";

const IngredientSelectSection = ({
  ingredients,
  setIngredients,
  ingredientOptions,
  loadingIngredients,
  formErrors,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={ingredientOptions}
        loading={loadingIngredients}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        value={ingredients}
        onChange={(e, newValue) => setIngredients(newValue)}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option._id}>
            <Checkbox checked={selected} sx={{ mr: 1 }} />
            {option.name}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Ingredients"
            placeholder="Search ingredients"
            error={!!formErrors?.ingredients} // safe optional chaining
            helperText={formErrors?.ingredients}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingIngredients ? <CircularProgress size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />

      {ingredients.length > 0 && (
        <Box
          sx={{
            mt: 2,
            maxHeight: 180,
            overflowY: "auto",
            border: "1px solid #eee",
            borderRadius: 2,
            p: 1,
          }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Selected Ingredients:
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {ingredients.map((ing) => (
              <Chip
                key={ing._id}
                label={ing.name}
                onDelete={() =>
                  setIngredients((prev) =>
                    prev.filter((i) => i._id !== ing._id)
                  )
                }
              />
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default IngredientSelectSection;
